import { translationKey } from '@change-corgi/core/i18n';
import type { TranslationKey } from '@change-corgi/core/i18n';

export const MAX_IMAGE_FILE_SIZE = 6000000;
// Raw (pre-compression) ceiling for flows that compress via onUseCompressor — generous enough to
// let a large-but-compressible phone photo through, since MAX_IMAGE_FILE_SIZE is enforced after compression instead.
export const MAX_RAW_IMAGE_FILE_SIZE_FOR_COMPRESSION = 20000000;
export const UPLOAD_ERROR_MESSAGES: {
	UNSUPPORTED_FILE_TYPE: TranslationKey;
	IMAGE_TOO_LARGE: TranslationKey;
	IMAGE_TOO_SMALL: TranslationKey;
	UPLOADED_TOO_MANY_FILES: TranslationKey;
	CATCH_ALL: TranslationKey;
	UNKNOWN_ERROR: TranslationKey;
	DROP_ONE_AT_A_TIME: TranslationKey;
} = {
	UNSUPPORTED_FILE_TYPE: translationKey('corgi.components.media_uploader.error.unsupported_file_type'),
	IMAGE_TOO_LARGE: translationKey('corgi.components.media_uploader.error.image_too_large'),
	IMAGE_TOO_SMALL: translationKey('corgi.components.media_uploader.error.image_too_small'),
	UPLOADED_TOO_MANY_FILES: translationKey('corgi.components.media_uploader.error.uploaded_too_many_files'),
	CATCH_ALL: translationKey('corgi.components.media_uploader.error.catch_all'),
	UNKNOWN_ERROR: translationKey('corgi.components.media_uploader.error.unknown_error'),
	DROP_ONE_AT_A_TIME: translationKey('corgi.components.media_uploader.error.drop_one_at_a_time'),
};
export const MIN_IMAGE_DIMENSION_SIZE = {
	HEIGHT: 675,
	WIDTH: 1200,
};

export type UploadErrorMessages = typeof UPLOAD_ERROR_MESSAGES;

export function getMaxImageFileSize(): typeof MAX_IMAGE_FILE_SIZE {
	return MAX_IMAGE_FILE_SIZE;
}

export function getMaxRawImageFileSizeForCompression(): typeof MAX_RAW_IMAGE_FILE_SIZE_FOR_COMPRESSION {
	return MAX_RAW_IMAGE_FILE_SIZE_FOR_COMPRESSION;
}

export function getUploadErrorMessages(): UploadErrorMessages {
	return UPLOAD_ERROR_MESSAGES;
}

export function getMinImageDimensionSize(): typeof MIN_IMAGE_DIMENSION_SIZE {
	return MIN_IMAGE_DIMENSION_SIZE;
}
